export async function postJson<TRequest, TResponse>(
  url: string,
  data: TRequest,
  init?: Omit<RequestInit, 'method' | 'body'>
): Promise<TResponse> {
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data),
    ...init
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`POST ${url} failed with status ${response.status}: ${errorText}`);
  }

  return response.json() as Promise<TResponse>;
}
